import { useFcm } from './fcm';

export function useShowSuggestedVictoriousPetitions(): boolean {
	const { suggestedVictoriousPetitionsEnabled } = useFcm();

	return suggestedVictoriousPetitionsEnabled;
}
